import { Point, PointGroup } from 'angular2-signaturepad';

export class InputDrawLicense {
  title: string;
  data: PointGroup[];
  dataURL: string;
  imageType: string | '' | 'image/jpeg' | 'image/svg+xml';
}
